import React from 'react';

import { Type } from '@robinhood/design';
import { DollarInputFormatter } from '@x1/util-format';

import IncomeModal from './IncomeModal';
import IconButton from 'src/components/creditApplication/IconButton';
import TextInput from 'src/components/creditApplication/TextInput';
import { useIsNfaStanford } from 'src/hooks/useAttribution';

interface PropsIface {
  value: string;
  onChange: (value: string) => void;
}

const IncomeInput = ({ value, onChange }: PropsIface) => {
  const [showIncomeDialog, setShowIncomeDialog] = React.useState<boolean>(false);
  const isNfaStanford = useIsNfaStanford();

  const _onChange = React.useCallback(
    ({ value }: { value: string }) => {
      const formatted = DollarInputFormatter.serialize(value);
      onChange(formatted);
    },
    [onChange],
  );

  const onShowIncomeDialog = React.useCallback(() => {
    setShowIncomeDialog(true);
  }, []);

  const onDismissIncomeDialog = React.useCallback(() => {
    setShowIncomeDialog(false);
  }, []);

  return (
    <>
      <TextInput
        placeholder='Annual income'
        value={value}
        onChange={_onChange}
        inputMode='numeric'
        endControl={
          // TODO (szhang): Figure out why HoverState has different base background color
          <IconButton type='button' icon='Info16' onClick={onShowIncomeDialog} aria-label='Show income details' />
        }
      />
      {isNfaStanford && (
        <Type.Text size='S'>
          {
            'Enter money you earn or reasonably expect to earn, regular deposits into your account (including from family), and scholarships, grants and financial aid after subtracting tuition and other required education costs.'
          }
        </Type.Text>
      )}
      {showIncomeDialog && <IncomeModal onDismiss={onDismissIncomeDialog} />}
    </>
  );
};

export default IncomeInput;
